// extracted by mini-css-extract-plugin
export default {"productTab":"productTab___HaGAn","title":"title___qVsmb","neighboursBox":"neighboursBox___MHdfX","infoItems":"infoItems___Th_mO"};